import React, { useMemo, useEffect, useContext } from 'react'
import usePrevious from 'hooks/usePrevious'
import { useDispatch } from 'react-redux'
import { useIdRegister } from 'hooks/useIdRegister'
import fetchUsersByArray from 'store/sagas/fetchUsersByArray'

const DEFAULT_CONTEXT: {
  registerUser: (userId: number) => void;
  unregisterUser: (userId: number) => void;
} = {
  registerUser: () => {},
  unregisterUser: () => {},
}

export const UserProviderContext = React.createContext(DEFAULT_CONTEXT)

export function UserProvider ({
  children
}) {
  const dispatch = useDispatch()

  const [ids, registerId, unregisterId] = useIdRegister<number>()
  const prevIds = usePrevious(ids)

  useEffect(() => {
    let addedIds: number[] = []

    if (ids.length) {
      if (prevIds?.length) {
        addedIds = ids.filter(boardId => !prevIds.includes(boardId))
      } else {
        addedIds = ids
      }
    }

    if (addedIds.length) {
      dispatch(fetchUsersByArray({
        userIds: addedIds,
      }))
    }
  }, [ids])

  const value = useMemo(() => ({
    registerUser: registerId,
    unregisterUser: unregisterId,
  }), [registerId, unregisterId])

  return (
    <UserProviderContext.Provider value={value}>
      {children}
    </UserProviderContext.Provider>
  )
}

export function useUserProvider (userId: number) {
  const { registerUser, unregisterUser } = useContext(UserProviderContext)

  useEffect(() => {
    registerUser(userId)

    return () => {
      unregisterUser(userId)
    }
  }, [userId])
}
